$(function() {
  // 会員バリデーション
  $(".member-submit").on("click", function(){
    $("#form-member").validationEngine('attach');
  })

  // 会員編集バリデーション
  $("#member-submit-edit").on("click", function() {
    if ( !$('#form-member-edit').validationEngine('validate')) {
    } else {
      if(!confirm('編集しますか？')){
        return false;
      }else{
        $('#form-member-edit')[0].submit();
        return false;
      }
    }
    return false;
  })

  // 会員削除チェック
  $(".member-delete").on("click", function(){
    company = $(this).data("company")
    if(!confirm(company + '様を削除しますか？')){
      return false;
    }
  }) 

  // ファイルサイズの単位変更
  $(".filesize-unit").each(function(){
    let filesizeB = $(this).text();
    switch (true) {
      case filesizeB >= 1048576:
        filesizeB = Math.floor(filesizeB/1024/1024) + " MB"
        break;
      case filesizeB >= 1024:
        filesizeB = Math.floor(filesizeB/1024) + " KB"
        break;
      default:
        filesizeB = filesizeB + " B"
        break;
    }
    $(this).text(filesizeB);
  })

  // 入稿削除チェック
  $(".post-delete").on("click", function(){
    if(!confirm('削除しますか？')){
      return false;
    }
  }) 

  // 一括（ダウンロード、削除）ボタン disabled
  $('input[type="checkbox"]').on("change",function() {
      if ($("input:checked").length > 0) {
        $(".disabled-check").prop('disabled', false)
      } else {
        $(".disabled-check").prop('disabled', true)
      }
  })

  // 一括ダウンロード
  $("#bulk-download").on("click", function(){
    $("#form-download")[0].submit();
  })

  // 一括削除
  $("#bulk-delete").on("click", function(){
    if(!confirm('削除しますか？')){
      return false;
    } else {
      // local
      // let deletePath = "/managements/posts_delete"
      // 本番
      let deletePath = "/system/managements/posts_delete"
      let form = $("#form-download")[0]
      form = $(form).attr('action', deletePath);
      $(form)[0].submit();
    }
  })

  // チェックホバー
  $('.post-show-tr').each(function(){
    $(this).on('change', function(){
      if($(this).css('background-color') == 'rgb(222, 226, 230)'){
        $(this).css({'background-color':'#f8f9fa'});
      } else {
        $(this).css({'background-color':'#dee2e6'});
      }
    })
  })

  // 「全選択」する
  $('#all').on('click', function() {
    $("input[name='download[]']").prop('checked', this.checked);
    if ($("input[name='download[]']").prop('checked')) {
      $(".post-show-tr").css({'background-color':'#dee2e6'});
    } else {
      $(".post-show-tr").css({'background-color':'#f8f9fa'});
    }
  });
  // 「全選択」以外のチェックボックスがクリックされたら、
  $("input[name='download[]']").on('click', function() {
    if ($('.post-show-tr :checked').length == $('.post-show-tr .input-check').length) {
      $('#all').prop('checked', true);
    } else {
      $('#all').prop('checked', false);
    }
  });

})